module.exports = __webpack_public_path__ + "img/money.1a416460.svg";